<template>
    <v-list-group>
      <template v-slot:activator="{ props }">
        <v-list-item v-bind="props">
          <template v-slot:prepend>
            <v-icon icon="mdi-alert" class="mr-2"></v-icon>
          </template>
          <v-list-item-title>Errors: {{ errors?.length || 0 }}</v-list-item-title>
        </v-list-item>
      </template>
  
      <v-list-group 
        v-for="error in errors" 
        :key="error.customerId"
        class="error-item mb-2"
      >
        <template v-slot:activator="{ props }">
          <v-list-item 
            v-bind="props"
            :class="getErrorClass(error.errorMessage)"
            class="rounded"
          >
            <v-list-item-title>{{ error.errorMessage }}</v-list-item-title>
            <template v-slot:append>
              <v-btn
                icon="mdi-delete"
                size="small"
                color="error"
                variant="text"
                @click.stop="deleteError(error.customerId, error.id)"
                :loading="deletingId === error.customerId"
              ></v-btn>
            </template>
          </v-list-item>
        </template>
        <v-list-item class="pl-4">
          <v-list-item-text>
            <div class="text-grey">Created at: {{ new Date(error.createdAt).toLocaleString() }}</div>
          </v-list-item-text>
        </v-list-item>
        <v-list-item class="pl-4">
          <v-list-item-text>
            <pre class="error-details pa-2 rounded">{{ error.errorDetails }}</pre>
          </v-list-item-text>
        </v-list-item>
      </v-list-group>
    </v-list-group>
  </template>
  
  <script setup lang="ts">
  import { ref } from 'vue';
  import { api } from '@/services/api';
  import type errorModel from '@/models/errorModel';
  const props = defineProps<{
    errors?: errorModel[];
  }>();

  const emit = defineEmits(['error-deleted']);
  const deletingId = ref<string | null>(null);

  const getErrorClass = (errorMessage: string) => {
    if (errorMessage.includes('Unauthorized')) {
      return 'error-unauthorized'
    }
    if (errorMessage.includes('BadRequest')) {
      return 'error-badrequest'
    }
    return 'error-default'
  }

  const deleteError = async (customerId: string, errorId: string) => {
    try {
      deletingId.value = customerId;
      await api.deleteError(customerId, errorId);
      emit('error-deleted');
    } catch (error) {
      console.error('Error deleting error:', error);
    } finally {
      deletingId.value = null;
    }
  };
  </script>

  <style scoped>
  .error-item {
    border-left: 4px solid transparent;
  }

  .error-unauthorized {
    background-color: rgb(253, 236, 234, 0.4);
    border-left-color: #ff5252;
  }

  .error-badrequest {
    background-color: rgb(255, 244, 229, 0.4);
    border-left-color: #ffa726;
  }

  .error-default {
    background-color: rgb(232, 234, 246, 0.4);
    border-left-color: #3f51b5;
  }

  .error-details {
    background-color: rgb(0, 0, 0, 0.03);
    font-family: monospace;
    white-space: pre-wrap;
    word-break: break-all;
  }
  </style>